import { Text, Tooltip } from '@radix-ui/themes'
import cn from 'clsx'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { testId } from '#app/utils/client/test-id.ts'
import { payments } from '#app/utils/paymetns.ts'

/* -------------------------------------------------------------------------------------------------
 * Text id
 * -----------------------------------------------------------------------------------------------*/

enum TEST_ID {
	'payment-methods' = 'payment-methods',
}

/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	uiPayment = 'ui-payment',
}

/* -------------------------------------------------------------------------------------------------
 * Payment
 * -----------------------------------------------------------------------------------------------*/

type PaymentProps = {
	className?: string
}

const Payment: React.FC<PaymentProps> = ({ className }) => {
	const { t } = useTranslation(I18NEXT.uiPayment)

	return (
		<ul className={className} {...testId(TEST_ID['payment-methods'])}>
			{payments.map(
				({ Icon, label, type, region }) =>
					//@ts-ignore
					!!(
						Icon &&
						type &&
						region.filter((value) => ['global', 'europe'].indexOf(value) !== -1)
					) && (
						<li key={label}>
							<Tooltip content={t(`paymentMethod.${label}`)}>
								<Text aria-label={label}>
									<Icon
										className={cn(
											'h-10 w-10 fill-gray-11',
											'transition duration-200 ease-in-out',
											'hover:scale-110',
										)}
									/>
								</Text>
							</Tooltip>
						</li>
					),
			)}
		</ul>
	)
}
Payment.displayName = 'Payment'

/* -----------------------------------------------------------------------------------------------*/

export { Payment, I18NEXT as PAYMENT_I18NEXT, TEST_ID as PAYMENT_TEST_ID }
